const minin = {
  data() {
    return {
      formCtrl: [
        {
          ...this.ctrls.ZhuangHuoRiQi,
          label: "装货日期：",
          placeholder: "选择日期",
        },
      ],
      searchDateOptions: [
        { ...this.ctrls.ZhuangHuoRiQi, },
        { ...this.ctrls.XieHuoRiQi, },
      ],
      selectKeyOptions: [
        { label: '过磅单', value: 'isvoice', },
        { label: '逾期状态', value: 'status', },
      ],
      selectValueOptions: {
        isvoice: [
          { label: '全部', value: '' },
          { label: '未回收', value: 1, },
          { label: '已回收', value: 2, },
        ],
        status: [
          { label: '全部', value: '' },
          { label: '已到期', value: 1, },
          { label: '快到期', value: 2, },
          { label: '未到期', value: 3, },
        ],
      },
      searchKeyOptions: [
        { label: '客户名称', value: 'shname', },
        { label: '车牌号', value: 'license', },
      ],
      baseParams: ['ischeck', 'isstatus'],
      tableHeight: 500,
      btnloading: false,
    };
  },
  methods: {
    getExport() {
      this.btnloading = true
      let url = `order/expicture`;
      const params = {
        // userid: this.user.id,
        order_list: []
      }
      if (this.tableData && this.tableData.length) {
        this.tableData.map(v => {
          params.order_list.push(v.id)
        })
      }
      console.log(url, params)
      this.post(url, params, (res) => {
        this.btnloading = false
        // console.log(res)
        const { msg, url } = res
        if (msg === 'success' && url) {
          console.log(url)
          var link = document.createElement('a')
          link.href = url
          // link.download = "过磅单"
          link.click()
        } else {
          this.$message({
            message: msg || '导出失败，请稍后再试！',
            type: 'error',
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    
    delete({ order_num }) {
      console.log('order_num', order_num)
      this.$prompt('删除原因', '确认删除吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(({ value }) => {
        this.delReq(order_num, value);
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    delReq(order_num, del_desc) {
      this.loading = true
      let url = `order/delorder`;
      const params = {
        userid: this.user.id,
        order_num,
        del_desc
      }
      this.post(url, params, ({
        msg
      }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '删除失败，请稍后重试！'
        });
      })
    },
    showPosition({ license, is_gps }) {
      if (is_gps != 1) {
        this.$message({
          type: 'error',
          message: '未绑定定位设备!'
        });
        return;
      }
      console.log(license)
      this.$router.push(`/order/position?license=${license}`)
    },
  },
  mounted() {
    this.formCtrl.map(v => {
      const val = this.formInline[v.keyName]
      this.formInline[v.keyName] = val || null
    })
    this.getList()
  },
}

export default minin